import { Component, Prop, h } from '@stencil/core';
import Icon from '../svg/user-tie.svg'
@Component({
  tag: 'cr-icon-facility-operator',
  styleUrl: '../cr-icon.css',
  shadow: true,
})
export class CrIconFacilityOperator {
  /**
   * The size of the icon - can be 'small', 'medium' or 'large'
   */
  @Prop() size: string

  render() {

    return (
      <div
        class={this.size}
        innerHTML={Icon}
      />
    );
  }
}
